<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="630"
    >
      <h3 slot="header" class="modal-header">修改手机号</h3>
      <div class="content">

        <Steps :current="current " class="mb32" >
          <Step title="验证身份、手机号" content=""></Step>
          <Step title="完成" content=""></Step>
        </Steps>

        <div v-if="current===0">
          <Form :model="formData" :label-width="100"  :rules="formRules" ref="formData" label-position="left">
            <FormItem label="手机号">
              {{phone}}
            </FormItem>
            <FormItem label="旧手机验证码" prop="oldVcode">
              <Input  class="item-width" v-model="formData.oldVcode" ></Input>
              <Button type="primary" @click.stop="getOldVcode" :disabled="disabled1">{{!disabled1?'获取验证码':timeOld}}</Button>
            </FormItem>
            <FormItem label="新手机号" prop="newPhone">
              <Input   class="item-width" v-model="formData.newPhone"></Input>
            </FormItem>

            <FormItem label="新手机验证码" prop="newVcode">
              <Input  class="item-width" v-model="formData.newVcode" ></Input>
              <Button type="primary" @click.stop="getNewVcode" :disabled="disabled2 || !phoneValidate">{{!disabled2?'获取验证码':timeNew}}</Button>
            </FormItem>
          </Form>
        </div>

        <div v-if="current===1" class="text-align-c" style="padding: 40px 0 ">
          修改手机号完成！
          <br>
          <br>

          恭喜你，你的手机号已修改成功，请重新登录系统
        </div>

        <div class="text-align-c " style="margin-top: 40px">
          <!--<Button type="primary" @click.stop="toStep2" v-if="current===0">下一步</Button>-->
          <Button type="primary" @click.stop="toStep2" v-if="current===0" :loading="loading1">确定</Button>
          <Button type="primary" @click.stop="reLogin" v-if="current===1">确定</Button>
        </div>

      </div>


      <div slot="footer">
        <!--<Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button>-->
      </div>

    </Modal>
  </div>

</template>
<script>

  import {getImgVerifycode} from "../../../../api/systemmanage";
  import {oldPhonechangevcode,newPhonechangevcode,phonechange} from "../../../../api/personal";

  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      phone:{
        type: String,
        default: ''

      }

    },
    watch:{
      n(){
        this.clearData()
        // this.getImgVerifycode()
        this.isShow=true
      }
    },
    computed:{
      phoneValidate(){
        if(!this.formData || !this.formData.newPhone){
          return false

        }
        let pattern = /^1\d{10}$/
        return pattern.test(this.formData.newPhone)

      }

    },
    data(){
      const validatePhone = (rules,value,callback)=>{
        let pattern = /^1\d{10}$/

        if(pattern.test(value)){
          callback();
        }else{
          callback(new Error(' '));
        }

      }
      return {
        t2:null,
        timeNew:60,
        disabled2:false,

        t1:null,
        timeOld:60,
        disabled1:false,
        loading1:false,
        imgCodeErr:'',
        current:0,
        loading: true,
        isShow:false,
        formData:{
          oldVcode:'',
          newPhone:'',
          newVcode:'',
        },
        formRules:{
          newPhone:[ {required: true,validator: validatePhone, trigger:'blur'} ],
          oldVcode:[ {required: true, type:'string', message:' ', trigger:'blur'} ],
          newVcode:[ {required: true, type:'string', message:' ', trigger:'blur'} ],
        },
      }
    },
    methods:{
      clearData(){
        this.formData={
            oldVcode:'',
            newPhone:'',
            newVcode:'',
        }
        this.$refs['formData'] &&  this.$refs['formData'].resetFields()

      },
      reLogin(){
        this.$store.dispatch('Logout').then(res => {
          location.reload();
        })
      },
      getNewVcode(){
        newPhonechangevcode({phone:this.formData.newPhone}).then(res=>{
          this.$Message.success('验证码下发成功')

          this.disabled2=true
          this.setT2()
        }).catch(error=>{

        })

      },
      setT2(){
        this.t2=setInterval(()=>{
          if(this.timeNew<=1){
            clearInterval(this.t2)
            this.disabled2=false
            this.timeNew=60
          }
          this.timeNew--

        },1000)


      },
      setT1(){
        this.t1=setInterval(()=>{
          if(this.timeOld<=1){
            clearInterval(this.t1)
            this.disabled1=false
            this.timeOld=60
          }
          this.timeOld--

        },1000)


      },


      getOldVcode(){
        oldPhonechangevcode().then(res=>{
          this.$Message.success('验证码下发成功')
          this.disabled1=true
          this.setT1()
        }).catch(error=>{

        })
      },

      toStep2(){
        this.loading1=true
        this.$refs['formData'].validate(bool=>{
          if(bool){
            let params={
              oldPhone:this.phone,
              oldVcode:this.formData.oldVcode,
              newPhone:this.formData.newPhone,
              newVcode:this.formData.newVcode
            }

            phonechange(params).then(res=>{
              this.current=1
            }).catch(error=>{}).finally(()=>{
              // this.current=1
              this.loading1=false
            })
          }
          else {
            // this.changeLoading1()
            this.loading1=false
          }

        })

        // this.current=1

      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){

      },
      cancel(){

      },
      getImgVerifycode(){
        getImgVerifycode().then(res=>{
          if(!res.data){
            return
          }
          this.imgData = res.data.imgData
          this.imgId = res.data.imgId
          this.imgCode=res.data.imgCode
        }).catch(error=>{

        })
      }
    }

  }
</script>

<style scoped>
  .content{
    padding: 0 30px 30px 30px;
  }
  .v-middle{
    vertical-align: middle;
  }

</style>
